import * as React from "react"
import Typical from 'react-typical'
import {Link} from "gatsby"
import hero from "../../../../images/heero.webp"
import "./hero.css"

const Hero = () => (
    <section className="wrapper bg-white">
        <div className="container pt-8 pt-md-10 pb-10 pb-md-12">
            <div className="row gy-10 gy-md-13 gy-lg-0 align-items-center">
                <div
                    data-sal="slide-right"
                    data-sal-delay="100"
                    data-sal-easing="easeInExpo"
                    className="col-md-8 col-lg-5 d-flex mx-auto"
                >
                    <div className="img-blob rounded">
                        <img src={hero} alt=""/>
                    </div>
                </div>
                <div className="col-lg-6 offset-lg-1 col-xxl-5 text-center text-lg-end">
                    <h1
                        data-sal="slide-left"
                        data-sal-delay="200"
                        data-sal-easing="easeInExpo"
                        className="display-1 mb-5"
                    >
                        We're Texbond Nonwovens.
                    </h1>
                    <p
                        data-sal="slide-left"
                        data-sal-delay="300"
                        data-sal-easing="easeInExpo"
                        className="lead fs-25 lh-sm mb-7 px-md-10 px-lg-0 typewriter h-16"
                    >
                        <Typical
                            steps={['We specialise in the production of PP\n' +
                            'Spunbonded Nonwoven Fabrics and its Articles.']}
                            loop={1}
                            wrapper="p"
                        />
                    </p>
                    <div className="d-flex justify-content-center justify-content-lg-end pt-10 pt-sm-0">
                        <span
                            data-sal="slide-left"
                            data-sal-delay="400"
                            data-sal-easing="easeInExpo"
                        >
                            <Link to="/#" className="btn btn-lg btn-orange rounded-pill me-2">
                            Our Products
                            </Link>
                        </span>
                        <span
                            data-sal="slide-left"
                            data-sal-delay="500"
                            data-sal-easing="easeInExpo"
                        >
                            <Link to="/#contact" className="btn btn-lg btn-outline-orange rounded-pill">
                                Contact Us
                            </Link>
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </section>
)

export default Hero